'use client';

import { useLocale } from 'next-intl';
import getMainCategories, {
  Category,
  getCategoriesData,
} from '@/src/utils/getMainCategories';
import Link from 'next-intl/link';
import { usePathname } from 'next-intl/client';
import { useEffect, useState } from 'react';
import { useLocaleRoutes } from '@/src/utils/useLocaleRoutes';
import '@components/SubcategoriesNavbar.css';

export default function SubcategoriesNavbar({
  categorySlug = null,
  categoriesData,
}: {
  categorySlug?: string | null;
  categoriesData?: any;
}) {
  const locale = useLocale();
  const pathname = usePathname();
  const path = useLocaleRoutes();

  categorySlug = null;
  const firstPath = pathname.split('/')[1];
  getMainCategories().map((mainCat: Category) => {
    if (firstPath === path(mainCat.slug)) {
      categorySlug = mainCat.slug;
    }
  });
  const category = categorySlug ? getCategoriesData(categorySlug) : null;

  const catData = categoriesData;

  const getCategoryCount = (id: number) => {
    let count = 0;
    catData?.data?.forEach((cat: any) => {
      if (cat.id === id) {
        count = cat.ads || 0;
      }
    });
    return count;
  };

  let showSubCategories = false;

  const [ariaHidden, setAriaHidden] = useState(true);

  useEffect(() => {
    setAriaHidden(true);
    if (categorySlug) {
      setTimeout(() => {
        setAriaHidden(false);
      }, 50);
    }
  }, [categorySlug]);

  const subCategories = !category ? null : (
    <div
      className='subcategories mx-auto mb-4 w-full max-w-[90rem] lg:max-w-[85rem]'
      aria-hidden={ariaHidden}
    >
      <div>
        <ul className='flex flex-wrap gap-4 gap-y-2 bg-[#262626] p-4 px-10'>
          {category.children &&
            Object.keys(category.children)
              .sort((a, b) => {
                const subcatA = category.children[a];
                const subcatB = category.children[b];
                const nameA = subcatA['name-' + locale];
                const nameB = subcatB['name-' + locale];
                return nameA?.localeCompare(nameB) || 0;
              })
              .map((subCatSlug) => {
                const subCat = category.children[subCatSlug];
                const href =
                  '/' +
                  category['slug-' + locale] +
                  '/' +
                  subCat['slug-' + locale];
                const count = subCat.count;
                if (!count) {
                  return null;
                }
                showSubCategories = true;
                return (
                  <li key={subCat.id}>
                    <Link
                      href={href}
                      className={`whitespace-nowrap hover:text-white hover:underline ${
                        pathname === href ? 'text-brand' : 'text-white'
                      }`}
                    >
                      {subCat['name-' + locale]}{' '}
                      <span className='text-sm text-[#b2b2b2]'>({count})</span>
                    </Link>
                  </li>
                );
              })}
        </ul>
      </div>
    </div>
  );

  return <>{showSubCategories && subCategories}</>;
}
